

























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { tiposTelefoneList } from "@/models/commons/TelefoneModel";

@Component
export default class DadosTitular extends Vue {
  @Prop()
  titular!: any;
  tiposTelefone = tiposTelefoneList;

  formatarCNPJ(cnpj: string) {
    if (cnpj) {
      return cnpj.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }
  }

  formatarTelefone(ddd: string, phone: string) {
    const telefone = (ddd + phone).replace(/[^\d]/g, "");
    if (telefone.length > 10) {
      return telefone.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
    } else {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
  }

  isCNPJ() {
    if (this.titular?.cpfCnpj) {
      return this.titular?.cpfCnpj?.length > 11;
    }
  }

  mounted() {
    console.log(this.titular);
  }
}
